"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _transport = require("@trycourier/transport");

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var useTransport = function useTransport(_ref) {
  var authorization = _ref.authorization,
      clientKey = _ref.clientKey,
      clientSourceId = _ref.clientSourceId,
      isOnline = _ref.isOnline,
      tenantId = _ref.tenantId,
      transport = _ref.transport,
      userSignature = _ref.userSignature,
      wsOptions = _ref.wsOptions;
  var transportRef = (0, _react.useRef)();
  var newTransport = (0, _react.useMemo)(function () {
    var _transportRef$current;

    if (transport) {
      return transport;
    }

    if (authorization && transportRef !== null && transportRef !== void 0 && (_transportRef$current = transportRef.current) !== null && _transportRef$current !== void 0 && _transportRef$current.authorization && transportRef !== null && transportRef !== void 0 && transportRef.current.transport) {
      var _transportRef$current2;

      var oldDecodedAuth = (0, _jwtDecode["default"])(transportRef === null || transportRef === void 0 ? void 0 : (_transportRef$current2 = transportRef.current) === null || _transportRef$current2 === void 0 ? void 0 : _transportRef$current2.authorization);
      var newDecodedAuth = (0, _jwtDecode["default"])(authorization);

      if (oldDecodedAuth.scope === newDecodedAuth.scope && oldDecodedAuth.tenantId === newDecodedAuth.tenantId) {
        transportRef.current.transport.renewSession(authorization);
        return transportRef.current.transport;
      }
    }

    if (!clientKey && !authorization) {
      if (undefined !== "production") {
        console.warn("Courier: Missing ClientKey or Authorization");
      }

      return;
    }

    if (!clientSourceId) {
      if (undefined !== "production") {
        console.warn("Courier: Missing ClientSourceId");
      }

      return;
    }

    if (authorization) {
      var courierTransport = new _transport.CourierTransport({
        tenantId: tenantId,
        authorization: authorization,
        clientSourceId: clientSourceId,
        wsOptions: wsOptions
      }); // keep track of the transport so we don't reconnect when we don't have to

      transportRef.current = {
        authorization: authorization,
        transport: courierTransport
      };
      return courierTransport;
    }

    if (clientKey) {
      var _courierTransport = new _transport.CourierTransport({
        tenantId: tenantId,
        clientSourceId: clientSourceId,
        clientKey: clientKey,
        userSignature: userSignature,
        wsOptions: wsOptions
      });

      return _courierTransport;
    }
  }, [tenantId, authorization, clientKey, transport, userSignature, wsOptions]);
  var isConnected = newTransport !== null && newTransport !== void 0 && newTransport.isConnected ? newTransport === null || newTransport === void 0 ? void 0 : newTransport.isConnected() : undefined;
  (0, _react.useEffect)(function () {
    if (!(newTransport instanceof _transport.CourierTransport)) {
      return;
    }

    if (!isOnline && isConnected) {
      newTransport.closeConnection();
    }

    if (isOnline && !isConnected) {
      newTransport.connect();
    }
  }, [newTransport, isConnected, isOnline]);
  return newTransport;
};

var _default = useTransport;
exports["default"] = _default;